<template>
    <div>
        <div class="col-12 mb-4 d-flex justify-content-between align-items-baseline">
            <h4>Vessels</h4>
            <button @click="newVessel"
                    :disabled="loading"
                    class="btn btn-primary">
                New vessel
            </button>
        </div>
        <VueGoodTable :columns="columns"
                      :rows="vessels"
                      @on-row-click="viewVessel"
                      :isLoading.sync="loading"
                      :pagination-options="{
                        enabled: true,
                      }"
                      styleClass="vgt-table condensed"
                      class="vgt-table--card"/>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { VueGoodTable } from 'vue-good-table';

export default {
  components: {
    VueGoodTable,
  },
  computed: {
    ...mapGetters({
      vessels: 'vessels/vessels',
    }),
  },
  data() {
    return {
      loading: false,
      columns: [],
    };
  },
  mounted() {
    this.columns = [
      {
        label: 'Name',
        field: 'name',
        filterOptions: {
          enabled: true,
        },
      },
    ];
    this.getVessels();
  },
  methods: {
    newVessel() {
      this.$router.push({
        name: 'vessel',
        params: { id: 'new' },
      });
    },
    getVessels() {
      this.loading = true;

      this.$store.dispatch('vessels/getVessels')
        .finally(() => {
          this.loading = false;
        });
    },
    viewVessel(event) {
      this.$router.push({
        name: 'vessel',
        params: { id: event.row.id },
      });
    },
  },
};
</script>
